import { useMemo } from 'react';

import SvgIcon from '@lcsc-ui/components/SvgIcon';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';

export default function MerchantServicePop({ resourceData }) {
  const dataList = useMemo(() => {
    return [
      {
        id: 1,
        title: '入驻登记',
        href: `${resourceData?.projectConfigVO?.lcscWwwUrl}/supplier/convass.html`,
        icon: 'provider-hz',
      },
      {
        id: 2,
        title: '供应商登录',
        href: 'https://vcp.szlcsc.com',
        icon: 'provider-login',
      },
    ];
  }, [resourceData]);

  function merchantBuriedPoint(idx, hf) {
    buriedPoint({
      pf: 'pc',
      ty: 'click',
      cp: 'TOP_HEADER',
      op: idx === 0 ? 'supplier_cooperation' : 'SUPPLIER_LOGIN',
      data: {
        hf,
      },
    });
  }
  return (
    <ul className="px-[8px] py-[4px]" data-spm="hd">
      {dataList.map((data, idx) => (
        <li key={idx} className="mb-[16px] last:mb-[0] flex items-center">
          <SvgIcon app="common" iconName={data.icon} className="w-[30px] h-[30px]" />
          <a
            className="text-[14px] text-black leading-[20px] ml-[10px]"
            aria-label={data.title}
            href={data.href}
            target="_blank"
            data-spm={data.id === 1 ? 'hz' : ''}
            onClick={() => merchantBuriedPoint(idx, data.href)}
          >
            {data.title}
          </a>
        </li>
      ))}
    </ul>
  );
}
